import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ManufacturerService } from "src/app/services/manufacturer.service";
import { SecurityService } from "src/app/services/security.service";

@Component({
  selector: "app-timeline",
  templateUrl: "./timeline.component.html",
  styleUrls: ["./timeline.component.scss"],
})
export class TimelineComponent implements OnInit {
  manufacturerTimeLineList: any[];
  color: string;
  id: any;
  routeParams: any;
  loading:boolean

  constructor(private manufacturerService: ManufacturerService,
    private securityService: SecurityService,
    route: ActivatedRoute) {
    this.routeParams = route.snapshot.params;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
    this.loading=true;
  }

  ngOnInit(): void {
    this.getmanufacturerTimeLine(true);
  }

  approvedStatusColor(statusType: number) {
    switch (statusType) {
      case 1:
        return '#10B759'
      case 2:
        return '#800080'
      case 3:
        return '#D80F0F'
      case 4:
        return '#3F67A7'
      case 5:
        return '#F74040'
    }
  }

  getmanufacturerTimeLine(refresh: boolean) {
    this.manufacturerTimeLineList = [];
    this.manufacturerService
      .getManufacturerTimeLine(this.id, refresh)
      .subscribe((result) => {
        if (result) {
          this.loading=false
          this.manufacturerTimeLineList = result;
          this.manufacturerTimeLineList.forEach(s =>
            s.eventTs = moment(s.eventTs).format('DD-MM-YYYY')
          )
        }
      });
  }
}
